/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_ACCOUNTS (state, accounts) {
    state.accounts = accounts
  },
  REMOVE_RECORD (state, itemId) {
    const accountIndex = state.accounts.findIndex((u) => u.id === itemId)
    state.accounts.splice(accountIndex, 1)
  }
}
